import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { NotificationDetailsFilterFormField, NotificationDetailsFilterFormValues } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: NotificationDetailsFilterFormValues) => void;
  initialValues: NotificationDetailsFilterFormValues;
  closeModal?: () => void;
};

export const NotificationDetailsFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<NotificationDetailsFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();


  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
  };

  const onFinish = (formValues: NotificationDetailsFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };

  //  const {  } = useGetDropDownData({
  //       flag: "deliverytype",
  //       searchId:0,
  //       SearchKey: ""
  //       });

    const { data:notificationStatus } = useGetDropDownData({
        flag: "status",
        searchId:0,
        SearchKey: ""
        });

  return (
    
    <Form<NotificationDetailsFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{width:'100%'}}>
        <StandardItemsWrapper style={{width:'100%'}}>
          {/* <div className='invoice_list' style={{width:'100%'}}> */}
          <Form.Item<NotificationDetailsFilterFormValues>
            label={'Search Customer'}
            name={NotificationDetailsFilterFormField.CustomerName}
          >
            <Input
              placeholder={'Search'}
            />
          </Form.Item>

           <Form.Item<NotificationDetailsFilterFormValues>
            label={'Status'}
            name={NotificationDetailsFilterFormField.is_active}
          >
             
            <Select
                                 
                                    placeholder="Please select"
                                    style={{ width: "100%" }}
                                    options={notificationStatus?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                      
                                />
         
          </Form.Item> 
          
          {/* <Form.Item<NotificationDetailsFilterFormValues>
            label={'Delivery Type'}
            name={NotificationDetailsFilterFormField.DeliveryType}
          >
               
            <Select
                                 
                                    placeholder="Please select"
                                    style={{ width: "100%" }}
                                    options={deliveryType?.notificationDropDownList?.map((res: any) => ({
                                        label: res.title,
                                        value: res.id
                                    }))}
                                      
                                />
        
          </Form.Item> */}
          {screens.lg && (
        <ContentFilters.ButtonsWrapper className='filter_btn'>
          <Button type='primary' htmlType='submit'>
            {t('common.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>  
    </Form>
  );
};
